import { render, staticRenderFns } from "./houdun.vue?vue&type=template&id=5c4534c8&scoped=true&"
import script from "./houdun.vue?vue&type=script&lang=js&"
export * from "./houdun.vue?vue&type=script&lang=js&"
import style0 from "./houdun.vue?vue&type=style&index=0&id=5c4534c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4534c8",
  null
  
)

export default component.exports